import { ATTACHMENT_PAGE } from "~/configs/consts";

export type ClientId = string;

export type SelfEmployed = "self_employed";
export type IndividualEntrepreneur = "individual_entrepreneur";
export type Company = "company";

export enum OrgTypeEnum {
  SelfEmployed = "self_employed",
  IndividualEntrepreneur = "individual_entrepreneur",
  Company = "company"
}

export enum QuestionnaireTypeEnum {
  RuCustomer = "ru_customer",
  RuPartner = "ru_partner"
}

export enum FileTypeEnum {
  PassportMain = "passport_main",
  PassportRegistration = "passport_registration"
}

export enum VatModeEnum {
  NPD = "npd",
  ORN = "orn",
  USN = "usn",
  AUSN = "ausn",
  PSN = "psn",
  ESHN = "eshn"
}

export enum NameStepsEnum {
  CompanyDetails = "company-details",
  ContactDetails = "contact-details",
  PayformDetails = "payform-details",
  AccountDetails = "account-details",
  PayformTechDetails = "payform-tech-details",
  MarketplaceDetails = "marketplace-details",
  AttachmentsDetails = "attachments-details",
  AdditionalDetails = "additional-details"
}

export enum NameStepsEnumPartner {
  CompanyDetails = "partner-company-details",
  AccountDetails = "partner-account-details",
  PayformDetails = "partner-payform-details",
  AttachmentsDetails = "partner-attachments-details"
}

export enum NamesOfFieldEnum {
  OrgType = "org_type",
  Name = "name",
  Inn = "inn",
  Ogrn = "ogrn",
  Ogrnip = "ogrnip",
  Kpp = "kpp",
  BankName = "bank_name",
  SettlementAccount = "settlement_account",
  CorrespondentAccount = "correspondent_account",
  BankBic = "bank_bic",
  LegalAddress = "legal_address",
  LegalAddressFiasId = "legal_address_fias_id",
  LegalAddressApartment = "legal_address_apartment",
  LegalAddressIsComplete = "legal_address_is_complete",
  PostalAddress = "postal_address",
  PostalAddressFiasId = "postal_address_fias_id",
  PostalAddressRadio = "postal_address_radio",
  PostalAddressCheckbox = "postal_address_checkbox",
  VatMode = "vat_mode",
  Vat = "vat",
  IsVat = "is_vat",
  SignatureInfo = "signature_info",
  LprName = "lpr_name",
  LprPhone = "lpr_phone",
  BuhName = "buh_name",
  BuhPhone = "buh_phone",
  TechName = "tech_name",
  TechPhone = "tech_phone",
  PayformPhone = "payform_phone",
  PayformEmail = "payform_email",
  PayformLinks = "payform_links",
  PayformLinkVk = "payform_link_vk",
  PayformLinkTg = "payform_link_tg",
  PayformLinkInstagram = "payform_link_instagram",
  PayformLinkOther = "payform_link_other",
  PayformLinkSite = "payform_link_site",
  CrmName = "crm_name",
  CrmNameFirst = "crm_name_first",
  CrmNameLast = "crm_name_last",
  CrmNamePatron = "crm_name_patron",
  CrmNameFullname = "crm_name_fullname",
  CrmPhone = "crm_phone",
  CrmEmail = "crm_email",
  CrmBirthday = "crm_birthday",
  CrmSocialLinks = "crm_social_links",
  CrmMessengerLink = "crm_messenger_link",
  CrmOccupation = "crm_occupation",
  PaymentNotificationEmail = "payment_notification_email",
  ProductType = "product_type",
  ProductName = "product_name",
  PayformName = "payform_name",
  EducationalMaterialsPlatform = "educational_materials_platform",
  EducationalMaterialsPlatformCustom = "educational_materials_platform_custom",
  GiftAgreedAiTranslationService = "gift_agreed_ai_translation_service",
  PayformPaymentMethods = "payform_payment_methods",
  ClientIntegrationInfo = "client_integration_info", // @deprecated
  IsNeedExternalIntegrations = "is_need_external_integrations",
  IsNeedRecurrentPayments = "is_need_recurrent_payments",
  ShopName = "shop_name",
  ProductDescription = "product_description",
  LogoFileId = "logo_file_id",
  LogoMainFileId = "logo_main_file_id",
  SuggestedLogoSelected = "suggested_logo_selected",
  PassportFileId = "passport_file_id",
  ClientFrom = "client_from",
  ClientFromOther = "client_from_other",
  ClientPromocode = "client_promocode",
  ClientLengthOfService = "client_length_of_service",
  IsWantToBecomePartner = "is_want_to_become_partner",
  IsHaveEducationalLicense = "is_have_educational_license",
  IsOffertAccepted = "is_offert_accepted",
  IsPrivacyAccepted = "is_privacy_accepted",
  IsPromoAccepted = "is_promo_accepted",
  PaymentMethodProdamusSubscription = "payment_method_prodamus_subscription",
  PromocodeReferral = "promocode_referral",
  PromocodeOwn = "promocode_own",
  PartnerLevel = "partner_level",
  Partnerships = "partnerships",
  PassportMainFileId = "passport_main_file_id",
  PassportRegistrationFileId = "passport_registration_file_id",
  DocumentAgreement1FileId = "document_agreement1_file_id",
  DocumentAgreement1NewFileId = "document_agreement1_new_file_id",
  DocumentAgreement2FileId = "document_agreement2_file_id",
  DocumentPricesTariffsFileId = "prices_tariffs_file_id",
  DocumentPricesTariffsLink = "prices_tariffs_link",
  IsWantCreatePayform = "is_want_create_payform",
  LrpProxyDocNumber = "lrp_proxy_doc_number",
  LrpProxyDocDate = "lrp_proxy_doc_date",
  IsNeedOnlineKassa = "is_need_online_kassa",
  // ApprovalDocument = "approval_document",
  PartnerConnectionWay = "partner_connection_way",
  IsProdamusPayClient = "is_prodamus_pay_client",
  Offer = "offer",
  OfferType = "offer_type",
  TopManager = "top_manager",
  ConsentTerms = "consent_terms",
  SncoHasNonFatfAccounts = "snco_has_non_fatf_accounts",
  SncoHasForeignTaxResidency = "snco_has_foreign_tax_residency",
  SncoRegistrationDate = "snco_registration_date",
  SncoRegistrationAuthority = "snco_registration_authority",
  SncoHasSelfEmployed = "snco_has_self_employed",
  SncoNoSelfEmployed = "snco_no_self_employed",
}

export type WebsiteType =
  | 'vk'
  | 'telegram'
  | 'instagram'
  | 'site'
  | 'other';

export interface Website {
  type: WebsiteType;
  url: string;
}

export interface ValidateWebsitesParams {
  websites: Website[];
}

export interface ValidatePromocodeParams {
  promo_code: string;
}

export type PayformLinkType =
  | NamesOfFieldEnum.PayformLinkVk
  | NamesOfFieldEnum.PayformLinkTg
  | NamesOfFieldEnum.PayformLinkInstagram
  | NamesOfFieldEnum.PayformLinkOther
  | NamesOfFieldEnum.PayformLinkSite;

export type FormData = Partial<AccountDetailsFormFields> &
  Partial<AdditionalDetailsFormFields> &
  Partial<CompanyDetailsFormFields> &
  Partial<ContactDetailsFormFields> &
  Partial<MarketplaceDetailsFormFields> &
  Partial<PayformDetailsFormFields> &
  Partial<PayformTechDetailsFormFields> &
  Partial<AttachmentsDetailsFormFields> &
  Partial<AccountDetailsFormFieldsPartner> &
  Partial<CompanyDetailsFormFieldsPartner> &
  Partial<AttachmentsDetailsFormFieldsPartner>;

export type SharedTypeRequestFields = AccountDetailsFormFields &
  AdditionalDetailsFormFields &
  CompanyDetailsFormFields &
  CompanyDetailsFormFields &
  ContactDetailsFormFields &
  MarketplaceDetailsFormFields &
  PayformDetailsFormFields &
  PayformTechDetailsFormFields &
  AccountDetailsFormFieldsPartner &
  CompanyDetailsFormFieldsPartner &
  AttachmentsDetailsFormFieldsPartner;

export interface AccountDetailsFormFields {
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.CrmPhone]: string;
  [NamesOfFieldEnum.IsWantToBecomePartner]: "yes" | "no";
  [NamesOfFieldEnum.CrmName]: string;
  [NamesOfFieldEnum.CrmEmail]: string;
}

export interface AdditionalDetailsFormFields {
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.ClientFrom]: string;
  [NamesOfFieldEnum.ClientPromocode]: string;
  [NamesOfFieldEnum.ClientLengthOfService]: "first_run" | "lower_than_year" | "greater_than_year";
}

export interface CompanyDetailsFormFields {
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.Name]: string;
  [NamesOfFieldEnum.Ogrn]: string;
  [NamesOfFieldEnum.Ogrnip]: string;
  [NamesOfFieldEnum.Kpp]: string;
  [NamesOfFieldEnum.VatMode]: "orn" | "npd";
  [NamesOfFieldEnum.Vat]: "no" | "0" | "10" | "20";
  [NamesOfFieldEnum.BankName]: string;
  [NamesOfFieldEnum.SettlementAccount]: string;
  [NamesOfFieldEnum.CorrespondentAccount]: string;
  [NamesOfFieldEnum.BankBic]: string;
  [NamesOfFieldEnum.LegalAddress]: string;
  [NamesOfFieldEnum.LegalAddressFiasId]: string;
  [NamesOfFieldEnum.PostalAddress]: string;
  [NamesOfFieldEnum.PostalAddressFiasId]: string;
  [NamesOfFieldEnum.SignatureInfo]: string;
  [NamesOfFieldEnum.Inn]: string;
  // [NamesOfFieldEnum.ApprovalDocument]: string;
}

export interface ContactDetailsFormFields {
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.LprName]: string;
  [NamesOfFieldEnum.LprPhone]: string;
  [NamesOfFieldEnum.BuhName]: string;
  [NamesOfFieldEnum.BuhPhone]: string;
  [NamesOfFieldEnum.TechName]: string;
  [NamesOfFieldEnum.TechPhone]: string;
}

export interface MarketplaceDetailsFormFields {
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.ShopName]: string;
  [NamesOfFieldEnum.ProductDescription]: string;
}

export interface PayformDetailsFormFields {
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.PayformPhone]: string;
  [NamesOfFieldEnum.PayformEmail]: string;
  [NamesOfFieldEnum.PayformLinkVk]: string;
  [NamesOfFieldEnum.PayformLinkTg]: string;
  [NamesOfFieldEnum.PayformLinkInstagram]: string;
  [NamesOfFieldEnum.PayformLinkOther]: string;
  [NamesOfFieldEnum.PayformLinkSite]: string;
}

export interface PayformTechDetailsFormFields {
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.PayformName]: string;
  [NamesOfFieldEnum.PaymentNotificationEmail]: string;
  [NamesOfFieldEnum.ProductType]: string;
  [NamesOfFieldEnum.ProductName]: string;
  [NamesOfFieldEnum.PayformPaymentMethods]: string[];
  [NamesOfFieldEnum.ClientIntegrationInfo]: string;
  [NamesOfFieldEnum.EducationalMaterialsPlatform]: string;
  [NamesOfFieldEnum.EducationalMaterialsPlatformCustom]: string;
  [NamesOfFieldEnum.GiftAgreedAiTranslationService]: "yes" | "no";
  [NamesOfFieldEnum.IsHaveEducationalLicense]: "yes" | "no";
  [NamesOfFieldEnum.PaymentMethodProdamusSubscription]: "settlement_account" | "other";
}

export interface AttachmentsDetailsFormFields {
  [NamesOfFieldEnum.LogoFileId]?: number[];
  [NamesOfFieldEnum.PassportFileId]?: number[];
  [NamesOfFieldEnum.PassportMainFileId]?: number[];
  [NamesOfFieldEnum.PassportRegistrationFileId]?: number[];
  [NamesOfFieldEnum.DocumentAgreement1FileId]?: any;
  [NamesOfFieldEnum.DocumentAgreement2FileId]?: any;
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.IsOffertAccepted]: 1;
  [NamesOfFieldEnum.IsPrivacyAccepted]: 1;
}

export type AttachmentsDetailsError = null | {
  has: 0 | 1;
  message: string;
};

/**  ------ partner steps ------  */
export interface AccountDetailsFormFieldsPartner {
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.CrmName]: string;
  [NamesOfFieldEnum.Name]: string;
  [NamesOfFieldEnum.CrmEmail]: string;
  [NamesOfFieldEnum.CrmPhone]: string;
  [NamesOfFieldEnum.CrmMessengerLink]: string;
  [NamesOfFieldEnum.CrmSocialLinks]: string;
  [NamesOfFieldEnum.CrmOccupation]: string;
  [NamesOfFieldEnum.PromocodeReferral]: string;
  [NamesOfFieldEnum.PromocodeOwn]: string;
  [NamesOfFieldEnum.PartnerLevel]: string;
  [NamesOfFieldEnum.Partnerships]: string[];
}

export interface CompanyDetailsFormFieldsPartner {
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.Inn]: string;
  [NamesOfFieldEnum.BankBic]: string;
  [NamesOfFieldEnum.BankName]: string;
  [NamesOfFieldEnum.SettlementAccount]: string;
  [NamesOfFieldEnum.CorrespondentAccount]: string;
  [NamesOfFieldEnum.LegalAddress]: string;
  [NamesOfFieldEnum.LegalAddressFiasId]: string;
  [NamesOfFieldEnum.IsWantCreatePayform]: string;
  [NamesOfFieldEnum.Ogrn]: string;
  [NamesOfFieldEnum.Kpp]: string;
  [NamesOfFieldEnum.Ogrnip]: string;
  [NamesOfFieldEnum.VatMode]: VatModeEnum;
  [NamesOfFieldEnum.Vat]: string;
  [NamesOfFieldEnum.IsVat]: string;
  // [NamesOfFieldEnum.ApprovalDocument]: string;
}

export interface PayformDetailsFormFieldsPartner {
  [NamesOfFieldEnum.PayformName]: string;
  [NamesOfFieldEnum.ProductName]: string;
  [NamesOfFieldEnum.ProductType]: string;
  [NamesOfFieldEnum.ProductDescription]: string;
  [NamesOfFieldEnum.PayformLinks]?: string;
  [NamesOfFieldEnum.ShopName]: string;
}

export interface AttachmentsDetailsFormFieldsPartner {
  [NamesOfFieldEnum.PassportMainFileId]?: number[];
  [NamesOfFieldEnum.PassportRegistrationFileId]?: number[];
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.IsOffertAccepted]: 1;
  [NamesOfFieldEnum.IsPrivacyAccepted]: 1;
}

/**  ------ partner steps end ------  */

/**  ------ customer v2 steps ------  */
export enum NameStepsEnumCustomerV2 {
  AccountDetails = "step1",
  CompanyDetails = "step2",
  PayformTechDetails = "step3",
  AttachmentsDetails = "step4",
  AdditionalDetails = "step5"
}

export type FormDataCustomerV2 = Partial<AccountDetailsFormFieldsCustomerV2> &
  Partial<CompanyDetailsFormFieldsCustomerV2> &
  Partial<PayformTechDetailsFormFieldsCustomerV2> &
  Partial<AdditionalDetailsFormFieldsCustomerV2> &
  Partial<AttachmentsDetailsFormFieldsCustomerV2>

export type SharedTypeRequestFieldsCustomerV2 = AccountDetailsFormFieldsCustomerV2 &
  CompanyDetailsFormFieldsCustomerV2 &
  PayformTechDetailsFormFieldsCustomerV2 &
  AdditionalDetailsFormFieldsCustomerV2 &
  AttachmentsDetailsFormFieldsCustomerV2

export interface AccountDetailsFormFieldsCustomerV2 {
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.CrmNameFirst]: string;
  [NamesOfFieldEnum.CrmNameLast]: string;
  [NamesOfFieldEnum.CrmNamePatron]: string;
  [NamesOfFieldEnum.CrmEmail]: string;
  [NamesOfFieldEnum.CrmPhone]: string;
  [NamesOfFieldEnum.CrmBirthday]: string;
  [NamesOfFieldEnum.Inn]: string;
  [NamesOfFieldEnum.Ogrn]: string;
  [NamesOfFieldEnum.Ogrnip]: string;
  [NamesOfFieldEnum.LegalAddress]: string;
  [NamesOfFieldEnum.LegalAddressApartment]: string;
  [NamesOfFieldEnum.PostalAddress]: string;
  [NamesOfFieldEnum.PostalAddressRadio]: string;
  [NamesOfFieldEnum.Name]: string;
  // ---- additiaonal fields
  [NamesOfFieldEnum.LprName]: string;
  [NamesOfFieldEnum.LprPhone]: string;
  [NamesOfFieldEnum.LrpProxyDocNumber]: string;
  [NamesOfFieldEnum.LrpProxyDocDate]: string;
  [NamesOfFieldEnum.BuhName]: string;
  [NamesOfFieldEnum.BuhPhone]: string;
  [NamesOfFieldEnum.TechName]: string;
  [NamesOfFieldEnum.TechPhone]: string;
}

export interface CompanyDetailsFormFieldsCustomerV2 {
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.BankBic]: string;
  [NamesOfFieldEnum.BankName]: string;
  [NamesOfFieldEnum.SettlementAccount]: string;
  [NamesOfFieldEnum.CorrespondentAccount]: string;
  [NamesOfFieldEnum.VatMode]: VatModeEnum;
  [NamesOfFieldEnum.Vat]: string;
  [NamesOfFieldEnum.IsVat]: string;
}

export interface PayformTechDetailsFormFieldsCustomerV2 {
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.ProductType]: string;
  [NamesOfFieldEnum.ProductName]: string;
  [NamesOfFieldEnum.ProductDescription]: string;
  [NamesOfFieldEnum.PayformName]: string;
  [NamesOfFieldEnum.PayformPhone]: string;
  [NamesOfFieldEnum.PayformEmail]: string;
  [NamesOfFieldEnum.PayformLinkVk]: string;
  [NamesOfFieldEnum.PayformLinkTg]: string;
  [NamesOfFieldEnum.PayformLinkInstagram]: string;
  [NamesOfFieldEnum.PayformLinkOther]: string;
  [NamesOfFieldEnum.PayformLinkSite]: string;
  [NamesOfFieldEnum.PayformPaymentMethods]: string[];
  [NamesOfFieldEnum.LogoMainFileId]: string;
  [NamesOfFieldEnum.IsHaveEducationalLicense]: "yes" | "no";
  [NamesOfFieldEnum.IsNeedOnlineKassa]: "yes" | "no";
  [NamesOfFieldEnum.IsNeedExternalIntegrations]: "yes" | "no";
  [NamesOfFieldEnum.IsNeedRecurrentPayments]: "yes" | "no";
}

export interface AdditionalDetailsFormFieldsCustomerV2 {
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.ClientFrom]: string;
  [NamesOfFieldEnum.ClientFromOther]: string;
  [NamesOfFieldEnum.PaymentMethodProdamusSubscription]: string;
  [NamesOfFieldEnum.ClientPromocode]: string;
}

export interface AttachmentsDetailsFormFieldsCustomerV2 {
  [NamesOfFieldEnum.PassportMainFileId]?: number[];
  [NamesOfFieldEnum.PassportRegistrationFileId]?: number[];
  [NamesOfFieldEnum.OrgType]: OrgTypeEnum;
  [NamesOfFieldEnum.IsOffertAccepted]: 1;
  [NamesOfFieldEnum.IsPrivacyAccepted]: 1;
}

/**  ------ partner steps end ------  */

export type TypeInput = "input" | "inputNumber" | "inputDefault";

export type ConfigNamesFields = Partial<Record<NamesOfFieldEnum, string>>;

export type StatusConfirmationCode =
  | "initial-request-code"
  | "pending-request-code"
  | "resend-request-code"
  | "send-without-request-code";
export type StatusPage = "default" | typeof ATTACHMENT_PAGE | StatusConfirmationCode;

export type TypeDefaultSuggestionData = {
  fias_id: string;
  value: string;
  value_short: string;
  type: string;
};

export type TypeFullnameSuggestionData = {
  first_name: string;
  last_name: string;
  name: string;
  patronymic_name: string;
};

export type TypeSuggestionData = TypeDefaultSuggestionData | TypeFullnameSuggestionData;

export enum NamesOfFieldBankInfoEnum {
  BankName = "bank_name",
  BankBic = "bank_bic",
  BankInn = "bank_inn",
  BankKpp = "bank_kpp",
  BankCorrespondentAccount = "bank_correspondent_account"
}

export type TypeBankInfo = {
  [NamesOfFieldBankInfoEnum.BankName]: string;
  [NamesOfFieldBankInfoEnum.BankInn]: string;
  [NamesOfFieldBankInfoEnum.BankBic]: string;
  [NamesOfFieldBankInfoEnum.BankKpp]: string;
  [NamesOfFieldBankInfoEnum.BankCorrespondentAccount]: string;
};

export type ResponseDefaultFields = {
  success: 1 | 0;
  fields: {
    "crm_name"?: string,
    "inn"?: string,
    "name"?: string,
    "ogrnip"?: string,
    "is_active"?: boolean,
    "first_name"?: string,
    "last_name"?: string,
    "patronymic_name"?: string,
    "actuality_date"?: string,
    "registration_date"?: string,
    "liquidation_date"?: string,
    "top_manager"?: {
      "full_name"?: string,
      "first_name"?: string,
      "last_name"?: string,
      "patronymic_name"?: string,
      "role"?: string,
      "start_date"?: string
    },
  };
};

export type Offer = {
  "type": "default" | "custom",
  "file_name": null | string,
  "url": null | string,
  "responsibility_agreement": true,
  "offer_agreement": true
}

export type UIVersion = "v1" | "v2";